
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as MailIconComponent } from "./mail-icon.svg";

export const MailIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <MailIconComponent {...props} />;
};
